export default {
  CALCULATOR_COMMUNITIES ({ calculatorCommunities }) {
    return calculatorCommunities
  },
  APPLICATION_COMMUNITIES ({ applicationCommunities }) {
    return applicationCommunities
  }
}
